import { TbFileDescription } from "react-icons/tb"
import { classInput, classLabel } from "../../Utils/Types"
import { useEffect } from "react"

type Props = {
    visible: boolean
    dt_cadastro?: string,
    name_user_insert?: string,
    dt_last_updat?: string,
    name_user_last_update?: string
    dt_baixa?: string,
    name_user_baixa?: string
    closeModalEvent?: () => void
}

export const ModalAuditoriaDuplicatas = ({ visible, dt_cadastro, name_user_insert, name_user_last_update, dt_last_updat,dt_baixa, name_user_baixa, closeModalEvent }: Props) => {

    useEffect(() => {

        if (visible) {

            let modal = document.getElementById('modal_auditoria_dup')
            let modalContent = document.getElementById('modal_content_auditoria_dup')

            if (modal) {
                modal.style.visibility = 'visible'

                if (modalContent) {
                    modalContent.classList.remove('mt-[-400px]')
                    modalContent.classList.add('mt-24')
                }
            }

        } else {

            let modal = document.getElementById('modal_auditoria_dup')
            let modalContent = document.getElementById('modal_content_auditoria_dup')

            if (modal) {
                modal.style.visibility = 'hidden';

                if (modalContent) {
                    modalContent.classList.add('mt-[-400px]');
                    modalContent.classList.remove('mt-24');
                }
            }
        }

    }, [visible])

    return (

        <div id="modal_auditoria_dup" style={{ visibility: "hidden", backgroundColor: 'rgba(0,0,0, 0.6)' }} className="flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-50">

            <div id="modal_content_auditoria_dup" className="relative flex flex-col w-[90%] xl:w-[60%] h-[300px] bg-white dark:bg-slate-600 rounded-lg mt-[-400px] transition-all duration-300 justify-center items-center">


                {/* Header */}
                <div className={`absolute top-0 flex flex-row w-full h-[70px] items-center ml-4`}>

                    <div className={`flex items-center justify-center h-10 w-10 rounded-full bg-slate-100 dark:bg-slate-500 border border-slate-300 dark:border-slate-700 shadow-sm shadow-slate-500 dark:shadow-slate-800`}>
                        <TbFileDescription className={`w-5 h-5 text-slate-700 dark:text-slate-100`}></TbFileDescription>
                    </div>

                    <span className={`ml-2 text-lg text-slate-700 dark:text-slate-100`}>Auditoria</span>

                </div>
                {/* Header */}


                {/* Body */}

                <div className={`absolute top-[70px] bottom-[60px] w-full pt-4 flex flex-row`}>


                    <div className='w-full grid grid-cols-12 '>

                        <div className={`relative col-span-12 pl-2 pr-2 `}>
                            <label htmlFor="userCriacao" className={`px-1.5  xl:px-4 text-slate-600 dark:bg-slate-600 dark:text-slate-200 cursor-auto text-[14px]`}>Criador</label>
                            <input id="userCriacao" className={`${classInput} w-full px-1.5  xl:px-4 pt-1 dark:bg-slate-600 dark:text-slate-200 border-0 text-base cursor-auto`} value={name_user_insert} disabled={true} />
                        </div>

                        <div className={`relative col-span-12 pl-2 pr-2`}>
                            <label htmlFor="dtCriacao" className={`px-1.5 xl:px-4 text-slate-600  dark:bg-slate-600 dark:text-slate-200 cursor-auto text-[14px]`}>Data de Criação</label>
                            <input id="dtCriacao" className={`${classInput} w-full px-1.5  xl:px-4 pt-1 dark:bg-slate-600 dark:text-slate-200 border-0 text-base cursor-auto`} value={dt_cadastro} disabled={true} />
                        </div>

                    </div>

                    <div className='w-full grid grid-cols-12 '>

                        <div className={`relative col-span-12 pl-2 pr-2`}>
                            <label htmlFor="userAtt" className={`px-1.5 xl:px-4 text-slate-600  dark:bg-slate-600 dark:text-slate-200 cursor-auto text-[14px]`}>Atualizador</label>
                            <input id="userAtt" className={`${classInput} w-full px-1.5  xl:px-4 pt-1 dark:bg-slate-600 dark:text-slate-200 border-0 text-base cursor-auto`} value={name_user_last_update} disabled={true} />
                        </div>

                        <div className={`relative col-span-12 pl-2 pr-2`}>
                            <label htmlFor="dtAtt" className={`px-1.5 xl:px-4 text-slate-600  dark:bg-slate-600 dark:text-slate-200 cursor-auto text-[14px]`}>Data de Atualização</label>
                            <input id="dtAtt" className={`${classInput} w-full px-1.5  xl:px-4 pt-1 dark:bg-slate-600 dark:text-slate-200 border-0 text-base cursor-auto`} value={dt_last_updat} disabled={true} />
                        </div>

                    </div>

                    <div className='w-full grid grid-cols-12 '>

                        <div className={`relative col-span-12 pl-2 pr-2`}>
                            <label htmlFor="userBaixa" className={`px-1.5 xl:px-4 text-slate-600  dark:bg-slate-600 dark:text-slate-200 cursor-auto text-[14px]`}>Executor da Baixa</label>
                            <input id="userBaixa" className={`${classInput} w-full px-1.5  xl:px-4 pt-1 dark:bg-slate-600 dark:text-slate-200 border-0 text-base cursor-auto`} value={name_user_baixa} disabled={true} />
                        </div>

                        <div className={`relative col-span-12 pl-2 pr-2`}>
                            <label htmlFor="dtBaixa" className={`px-1.5 xl:px-4 text-slate-600  dark:bg-slate-600 dark:text-slate-200 cursor-auto text-[14px]`}>Data da Baixa</label>
                            <input id="dtBaixa" className={`${classInput} w-full px-1.5  xl:px-4 pt-1 dark:bg-slate-600 dark:text-slate-200 border-0 text-base cursor-auto`} value={dt_baixa} disabled={true} />
                        </div>

                    </div>

                </div>
                {/* Body */}


                {/* Footer */}
                <div className={`absolute bottom-0 w-full h-[60px] flex items-center justify-end bg-slate-100 dark:bg-slate-600 border border-slate-200 dark:border-slate-500 border-x-0 border-b-0 py-4 px-3 rounded-b-lg space-x-3`}>
                    <button
                        onClick={closeModalEvent}
                        className={`mt-3 ml-2 mr-2 inline-flex disabled:opacity-40 w-full justify-center rounded-md px-3 py-2 text-sm font-semibold text-slate-800 dark:text-slate-200 shadow-sm ring-1 ring-inset ring-slate-400 hover:ring-black hover:bg-slate-50 dark:ring-slate-400 dark:hover:ring-slate-500 dark:hover:bg-slate-700 sm:mt-0 sm:ml-0 sm:mr-0 sm:w-auto`}>
                        VOLTAR
                    </button>

                </div>
                {/* Footer */}

            </div>

        </div>

    )



}